import { useContext, memo } from 'react';
import { Bar } from 'react-chartjs-2';
import type { ChartData, ChartOptions } from 'chart.js';
import { reserveChartOption, reserveChartData } from './reserveChartData';

import { CalculatedDataContext, AllInputDataContext } from '../../../config';
import allStyles from './../AllCharts.module.css';

const ReserveChart = memo(() => {
  const {
    reservesAvali,
    dataIndex,
    annualConst,
    reserveRemaining
  } = useContext(CalculatedDataContext);
  const { optionsData } = useContext(AllInputDataContext);

  const chartData = reserveChartData({
    reservesAvali,
    dataIndex,
    optionsData,
    annualConst,
    reserveRemaining
  });
  const chartOptions = reserveChartOption();

  return (
    <div className={allStyles.dataChart}>
      <div className={allStyles.chartInnerCard}>
        {/* Narrow the generic helper return to the bar chart at the boundary. */}
        <Bar
          data={chartData as ChartData<'bar'>}
          options={chartOptions as ChartOptions<'bar'>}
        />
      </div>
    </div>
  );
});
export default ReserveChart;
